import { styled } from '@clickcease/cc-client-components-lib'

export const WrapperWithButtonsContainer = styled('div', {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

export const WrapperWithButtonsContent = styled('div', {
  width: 'calc(100% - 48px)',
  height: '100%',
  padding: '$6 $12',
  borderBottom: '1px solid $lightNeutral',
  marginBottom: 'auto',
})

export const WrapperWithButtonsButtons = styled('div', {
  width: 'calc(100% - 32px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '$4',
  padding: '$5 $8',
})
